import { createFileRoute } from '@tanstack/react-router';

import { ArchivedSessions } from '#modules/finder/features/posts/components/ArchivedSessions';

export const Route = createFileRoute(
  '/{-$locale}/_layout/_dashboard/_authed/dashboard/discover/sessions/_sessions/archive'
)({
  component: ArchivedSessions,
  ssr: false,
});
